import { AnalysisProseCard } from '@/pages/AnalysisResult/components';
import { useTranslation } from 'react-i18next';

interface PeakMomentOfPowerProps {
  peak?: string;
  staggerStart?: number;
}

export const PeakMomentOfPower = ({ peak, staggerStart }: PeakMomentOfPowerProps) => {
  const { t } = useTranslation('analysis');

  if (!peak) return null;

  return (
    <AnalysisProseCard
      title={t('analysisResult.peakMomentOfPower.peakMomentOfPower')}
      description={peak}
      descriptionVariant="statement"
      columns={1}
      staggerStart={staggerStart ?? 0}
    />
  );
};
